import React from 'react'
import { useTranslation } from 'react-i18next';
import SvgLightning from '../shared/SvgLightning.js';

const AddressBox = ({ 
    locationName, 
    street, 
    city, 
    phone, 
    note, 
    updateFromToDateTime, 
    date, 
    time, 
    editVisible, 
    editClick,
    hasLongProcessingItems,
    allItemsAreLongProcessing,
    earliestDate,
    earliestTime,
    earliestWithExpressDate,
    earliestWithExpressTime
}) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <div className="address" onClick={editVisible ? editClick : null}>
                <i className="fas fa-map-marker-alt"></i>
                <div className="checkout-step-box-content">
                    <div>{locationName}</div>
                    <div>{street}</div>
                    <div>{city}</div>
                </div>
                {editVisible &&
                    <a class="edit-link" href="#" onClick={editClick}>{t('cart.checkout.address.change')}</a>
                }
            </div>
            <div className="address" onClick={editVisible ? editClick : null}>
                <i className="fas fa-phone fa-rotate-90"></i>
                <div className="checkout-step-box-content">
                    <div>{phone ? phone : ' '}</div>
                </div>
                {editVisible &&
                    <a class="edit-link" href="#" onClick={editClick}>{t('cart.checkout.address.change')}</a>
                }
            </div>
            <div className="address" onClick={editVisible ? editClick : null}>
                <i className="far fa-comment-alt"></i>
                <div className="checkout-step-box-content">
                    <div>{note}</div>
                </div>
                {editVisible &&
                    <a class="edit-link" href="#" onClick={editClick}>{t('cart.checkout.address.change')}</a>
                }
            </div>
            <div className="address from-to-date-time" onClick={editVisible ? updateFromToDateTime : null}>
                <i className="fas fa-calendar-alt"></i>
                <div className="checkout-step-box-content">
                    <div>{date}</div>
                </div>
                <br />
                <i className="far fa-clock"></i>
                <div className="checkout-step-box-content">
                    <div>{time}</div>
                </div>
                {(earliestWithExpressDate && earliestWithExpressTime) || (earliestDate && earliestTime) ? (
                    <div style={{ fontSize: "12px", color: "#666", marginTop: "10px", marginBottom: "10px", fontStyle: "italic", whiteSpace: 'nowrap' }}>
                        {t('cart.checkout.earliestAvailableDate')}<br/>
                        {earliestWithExpressDate && earliestWithExpressTime && (
                            <>
                                - {earliestWithExpressDate} {earliestWithExpressTime}
                                &nbsp;–&nbsp;Express&nbsp;<SvgLightning /><br />
                            </>
                        )}
                        {earliestDate && earliestTime && (
                            <>- {earliestDate} {earliestTime}&nbsp;–&nbsp;normal</>
                        )}
                    </div>
                ) : null}
                
                
                {editVisible &&
                    <a class="edit-link" href="#" onClick={updateFromToDateTime}>{t('cart.checkout.address.change')}</a>
                }
                {/* Warning message for longProcessing items */}
                {hasLongProcessingItems && (
                    <div className="alert alert-warning mt-3 mb-0" role="alert" style={{ fontSize: "14px", marginTop: "10px" }}>
                        {allItemsAreLongProcessing 
                            ? t('cart.checkout.longProcessing.warning.messageOnlyLongProcessing', 'Deine Bestellung enthält Artikel, die eine längere Bearbeitungszeit benötigen.')
                            : t('cart.checkout.longProcessing.warning.message', 'Deine Bestellung enthält Artikel, die eine längere Bearbeitungszeit benötigen. Falls du trotzdem von unserem Express-Service profitieren möchtest, werden wir dich benachrichtigen, sobald der Artikel fertig ist, um ein zweites Lieferdatum mit dir zu vereinbaren. Für alle anderen Artikel gilt der Express-Service.')
                        }
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default AddressBox;